module.exports = __webpack_public_path__ + "img/lite.4b67319b.svg";